import { useEffect } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { monitorWsConnectionStart } from "../../redux/actions/monitorWsActions";
import './styles.css';
import { SortOrder } from "../Sort/Sort";
import { IPairExtended } from "../PairSpreadItem/PairSpreadItem";
import { PairSpreadItem2 } from "../PairSpreadItem2/PairSpreadItem2";
import { Settings2 } from "../Sessings/Settings";

export const Monitor = () => {
    const dispatch = useDispatch();

    const payload = useSelector(store => store.monitor.payload);
    const settings = useSelector(store => store.settings);

    useEffect(() => {
        dispatch(monitorWsConnectionStart());
    }, [dispatch]);

    const getSpreads = () => {
        if (!payload)
            return;

        let pairsData = Object.values(payload.pairsData).filter(item => item.strategy);

        if (settings.filterSets.approvedDividends)
            pairsData = pairsData.filter(item => item.dividend?.status === 'approved' || item.dividend?.status === 'declared');

        if (settings.filterSets.applicabilityStrategy)
            pairsData = pairsData.filter(item => item.strategy.actualFuture);
            
        switch (settings.sortOrder) {
            case SortOrder.Alpha:
                pairsData = pairsData
                    .sort((a: IPairExtended, b: IPairExtended) => {
                        const nameA = a.base.shortName.toLowerCase();
                        const nameB = b.base.shortName.toLowerCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
            break;

            case SortOrder.CloseDate:
                pairsData = pairsData
                    .sort((a: IPairExtended, b: IPairExtended) => (a.dividend?.closeDate ?? 0xffffffff) - (b.dividend?.closeDate ?? 0xffffffff));
            break;

            case SortOrder.DividendProfitRate:
                pairsData = pairsData
                    .sort((a: IPairExtended, b: IPairExtended) => (b.dividend?.profitRate ?? 0) - (a.dividend?.profitRate ?? 0));
            break;

            case SortOrder.Delta:
                pairsData = pairsData
                    .sort((a: IPairExtended, b: IPairExtended) => (b.strategy.delta ?? 0) - (a.strategy.delta ?? 0));
            break;

            case SortOrder.MaxProfitRate:
                pairsData = pairsData
                .sort((a: IPairExtended, b: IPairExtended) => (b.strategy.maxProfitRate ?? 0) - (a.strategy.maxProfitRate ?? 0));
            break;

            case SortOrder.DividendCutOffProfitRate:
                pairsData = pairsData
                    .sort((a: IPairExtended, b: IPairExtended) => (b.strategy.dividendCutOffProfitRate ?? 0) - (a.strategy.dividendCutOffProfitRate ?? 0));
            break;

            case SortOrder.ExpirationProfitRate:
                pairsData = pairsData
                    .sort((a: IPairExtended, b: IPairExtended) => (b.strategy.expirationProfitRate ?? 0) - (a.strategy.expirationProfitRate ?? 0));
            break;

            case SortOrder.MaxProfitRate:
            default:
                pairsData = pairsData
                .sort((a: IPairExtended, b: IPairExtended) => (b.strategy.maxProfitRate ?? 0) - (a.strategy.maxProfitRate ?? 0));
            break;                    
        }
        
        return pairsData.map((spread, index: number) => {
            return <PairSpreadItem2 key={`spread${index}`} { ...spread } />
        })
    }
    
    return (
        <>
            <Settings2 />
            {
                payload && getSpreads()
            }
        </>
    );
}